/* eslint-disable @stylistic/operator-linebreak */
import React from 'react';
import QuestionOptions from '../question_options';
import { Typography } from 'antd';
import styles from './question_card.module.scss';
import { checkScreenSize } from '../../utilities/breakpoints';
import { QuestionType } from '../../models/questionnaire.interface';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import { InteractionUserResponses } from 'models/interactions.interface';

const { Text } = Typography;

interface QuestionCardProps extends QuestionType {
  isBeingEdited: boolean;
  isAnswered: boolean;
  isActiveQuestion: boolean;
  feedbackScriptId?: number;
  index: number;
  disabled?: boolean;
  selectedAnswers?: InteractionUserResponses['answers'];
}

const QuestionCard: React.FC<QuestionCardProps> = ({
  text,
  id,
  uuid,
  isBeingEdited,
  isAnswered,
  isActiveQuestion,
  type,
  index,
  feedbackScriptId,
  selectedAnswers,
  disabled = false,
  ...props
}) => {
  const screenSize = checkScreenSize();
  const { answers } = props;

  const LinkRenderer = (props: any) => {
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
        ;
      </a>
    );
  };

  const getDataCy = () =>
    feedbackScriptId ? `feedback_question_${index}` : `question_${index}`;

  return (
    <div
      className={styles.questionCardContainer}
      style={{
        width:
          screenSize === 'mobile'
            ? isAnswered
              ? answers.length && isBeingEdited
                ? // display full width if answers are shown. Hug question text if answers are hidden.
                '100%'
                : 'auto'
              : answers?.length
                ? // display full with on unanswered questions that have answers (single select), otherwise hug question text (statement)
                '100%'
                : 'fit-content'
            : answers?.length
              ? isBeingEdited
                ? '100%'
                : 'auto'
              : 'fit-content',

        maxWidth: '450px',
      }}
    >
      <div>
        <Text
          className={`${styles.cardTitle} ${styles.markdown}`}
          data-cy={getDataCy()}
          data-cy-active-question={isActiveQuestion}
        >
          <ReactMarkdown
            components={{ a: LinkRenderer }}
            remarkPlugins={[remarkBreaks]}
          >
            {text}
          </ReactMarkdown>
        </Text>
      </div>
      {(isActiveQuestion) && (
        <QuestionOptions
          index={index}
          uuid={uuid}
          text={text}
          id={id}
          type={type}
          disabled={disabled}
          selectedAnswers={selectedAnswers}
          {...props}
          isBeingEdited={isBeingEdited}
        />
      )}
    </div>
  );
};

export default QuestionCard;
